import { fetchAuthSession } from '@aws-amplify/core';
import { Divider, withAuthenticator } from '@aws-amplify/ui-react';
import {
	AdsClickOutlined,
	CampaignOutlined,
	ConnectWithoutContactOutlined,
	DomainOutlined,
	DoNotTouchOutlined,
	EmailOutlined,
	ExpandLess,
	ExpandMore,
	FiberManualRecordOutlined,
	GroupOutlined,
	HelpOutlined,
	Inventory2Outlined,
	LeakAddOutlined,
	LogoutOutlined,
	MenuOutlined,
	MonetizationOnOutlined,
	PeopleOutlined,
	PhoneEnabledOutlined,
	RecentActorsOutlined,
	VerifiedOutlined,
} from '@mui/icons-material';
import {
	AppBar,
	Avatar,
	Box,
	Button,
	Collapse,
	CssBaseline,
	Drawer,
	IconButton,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	Menu,
	MenuItem,
	Toolbar,
	Tooltip,
	Typography,
} from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Link, Outlet } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { components, formFields } from './cognito-authentication';
import { InContact } from './contexts/InContact';
import { UserContext, loadContext } from './contexts/UserContext';
import {
	listItemButtonStyle,
	listItemIconSelectedStyle,
	listItemIconStyle,
	listItemSelectedStyle,
	subListItemButtonStyle,
	subListItemSelectedStyle,
} from './theme';

function MainLayout({ signOut }) {
	const securityOptions = {
		contacts: 0,
		inventoryManagement: 0,
		campaigns: 0,
		communicationProfiles: 0,
		digitalChannels: 0,
		suppression: 0,
		liveAgentSelect: 0,
		connection: 0,
		userManagement: 0,
		auditLog: 0,
	};

	const [userContext, setUserContext] = useState({
		tenant: '',
		tenantRole: '',
		company: '',
		name: '',
		apiKey: '',
		licenses: [],
		customFields: [],
		queryFields: [],
		rights: [],
		telephonyProvider: '',
		securityOptions: securityOptions,
	});

	const [userBtn, setUserBtn] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();
	const [contactsOpen, setContactsOpen] = useState(false);
	const [managementOpen, setManagementOpen] = useState(false);
	const [suppressionOpen, setSuppressionOpen] = useState(false);
	const [omniOpen, setOmniOpen] = useState(false);
	const [connectionOpen, setConnectionOpen] = useState(false);
	const [drawerVariant, setDrawerVariant] = useState('permanent');
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [miniDrawer, setMiniDrawer] = useState(false);
	const [screenSize, setScreenSize] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});
	const [drawerWidth, setDrawerWidth] = useState(315);

	useEffect(() => {
		const handleResize = () => {
			setScreenSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		if (screenSize.width < 768) {
			setDrawerVariant('temporary');
		} else {
			setDrawerVariant('permanent');
		}

		window.addEventListener('resize', handleResize);

		// Clean up the event listener when the component unmounts
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [screenSize.width]);

	useEffect(() => {
		if (miniDrawer) {
			setDrawerWidth(75);
		} else {
			setDrawerWidth(315);
		}
	}, [miniDrawer]);

	useEffect(() => {
		// set active states based on location
		const pathname = location.pathname;
		switch (true) {
			case pathname.includes('/contacts'):
				setContactsOpen(true);
				document.title = 'Contact Inventory'
				break;
			case pathname.includes('/custom-fields'):
				setContactsOpen(true);
				document.title = 'Custom Fields'
				break;
			case pathname.includes('/contact-import'):
				setManagementOpen(true);
				document.title = 'Contact Import'
				break;
			case pathname.includes('/bulk-edit'):
				setManagementOpen(true);
				document.title = 'Bulk Management'
				break;
			case pathname.includes('/segments'):
				setManagementOpen(true);
				document.title = 'Contact Segmentation'
				break;
			case pathname.includes('/field-mappings'):
				setManagementOpen(true);
				document.title = 'Field Mappings'
				break;
			case pathname.includes('/campaigns'):
				document.title = 'Campaigns'
				break;
			case pathname.includes('/profiles'):
				document.title = 'Communication Profiles'
				break;
			case pathname.includes('/message-templates'):
				setOmniOpen(true);
				document.title = 'Message Templates'
				break;
			case pathname.includes('/digital-profiles'):
				setOmniOpen(true);
				document.title = 'Digital Profiles'
				break;
			case pathname.includes('/suppression'):
				setSuppressionOpen(true);
				document.title = 'Suppression Profiles'
				break;
			case pathname.includes('/dnc-lists'):
				setSuppressionOpen(true);
				document.title = 'DNC'
				break;
			case pathname.includes('/contact-field-suppression'):
				setSuppressionOpen(true);
				document.title = 'Contact Field Suppression'
				break;
			case pathname.includes('/approver'):
				document.title = 'Live Agent Select'
				break;
			case pathname.includes('/connection-details'):
				setConnectionOpen(true);
				document.title = 'Connection Details'
				break;
			case pathname.includes('/disposition-mappings'):
				setConnectionOpen(true);
				document.title = 'Disposition Mappings'
				break;
			case pathname.includes('/users'):
				document.title = 'Users'
				break;
			case pathname.includes('/audit-log'):
				document.title = 'Audit Log'
				break;
			default:
				break;
		}
	}, [location]);

	// const [sftpExportSelected, setSftpExportSelected] = useState(false);
	// const [activityExportSelected, setActivityExportSelected] = useState(false);
	const [customFieldsSelected, setCustomFieldsSelected] = useState(false);
	const [contactInventorySelected, setContactInventorySelected] =
		useState(false);
	const [profileSelected, setProfileSelected] = useState(false);
	// const [fieldMappingsSelected, setFieldMappingsSelected] = useState(false);
	// const [contactImportSelected, setContactImportSelected] = useState(false);
	// const [bulkEditSelected, setBulkEditSelected] = useState(false);
	const [contactSegmentationSelected, setContactSegmentationSelected] =
		useState(false);

	function stringToColor(string) {
		let hash = 0;
		let i;

		/* eslint-disable no-bitwise */
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash);
		}

		let color = '#';

		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff;
			color += `00${value.toString(16)}`.slice(-2);
		}
		/* eslint-enable no-bitwise */

		return color;
	}

	function stringAvatar(name, size) {
		const firstName = name.split(' ')[0];
		const lastName = name.split(' ')[1];

		let initials;

		if (firstName && lastName) {
			initials = `${firstName[0]}${lastName[0]}`;
		} else {
			initials = name[0];
		}

		return {
			sx: {
				bgcolor: stringToColor(name),
				width: size,
				height: size,
				fontSize: size * 0.5,
			},
			children: initials,
		};
	}

	useEffect(() => {
		async function getData() {
			try {
				const session = await fetchAuthSession({ forceRefresh: true });
				const idToken = session.tokens?.idToken;
				const tenantId = idToken.payload['custom:tenant'];
				const { tenant, queryFields } = await loadContext(tenantId);
				const rights = idToken.payload['custom:securityRights'].split('|');
				const options = idToken.payload['custom:securityOptions']?.split('|');
				const approver = idToken.payload['custom:approver'];

				let context = {
					id: idToken.payload['sub'],
					tenantId: idToken.payload['custom:tenant'],
					tenantRole: idToken.payload['custom:tenantRole'],
					company: idToken.payload['custom:company'],
					name: idToken.payload['name'],
					email: idToken.payload['email'],
					apiKey: tenant.apiKey,
					customFields: tenant.customFields,
					queryFields: queryFields,
					licenses: tenant.licenses,
					rights: rights,
					telephonyProvider: tenant.telephonyProvider,
					skillLabel: '',
					dispositionLabel: '',
					country: tenant.country,
					securityOptions: setSecurityOptions(options),
				};

				switch (context.telephonyProvider) {
					case 'NiC':
						InContact.icSettings = tenant;
						context.skillLabel = 'Skill';
						context.dispositionLabel = 'Disposition';
						break;
					case 'Webex':
						context.skillLabel = 'Queue';
						context.dispositionLabel = 'Wrap Up Code';
					case 'Genesys':
						context.skillLabel = 'Queue';
						context.dispositionLabel = 'Wrap Up';
						break;
				}

				setUserContext(context);

				if (shouldNavigateToApprover(context.securityOptions, approver)) {
					navigate('/approver');
				} else {
					// Check to see if they have permissions at the current location.pathname and if not, navigate to the first available page
					if (location.pathname.includes('/contacts')) {
						if (context.securityOptions.contacts < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/custom-fields')) {
						if (context.securityOptions.contacts < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/contact-import')) {
						if (context.securityOptions.inventoryManagement < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/bulk-edit')) {
						if (context.securityOptions.inventoryManagement < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/segments')) {
						if (context.securityOptions.inventoryManagement < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/field-mappings')) {
						if (context.securityOptions.inventoryManagement < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/campaigns')) {
						if (context.securityOptions.campaigns < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/profiles')) {
						if (context.securityOptions.communicationProfiles < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/message-templates')) {
						if (context.securityOptions.digitalChannels < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/digital-profiles')) {
						if (context.securityOptions.digitalChannels < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/suppression')) {
						if (context.securityOptions.suppression < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/dnc-lists')) {
						if (context.securityOptions.suppression < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/contact-field-suppression')) {
						if (context.securityOptions.suppression < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/approver')) {
						if (context.securityOptions.liveAgentSelect < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/connection-details')) {
						if (context.securityOptions.connection < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/disposition-mappings')) {
						if (context.securityOptions.connection < 1) {
							navigateToAllowedPage(context);
						}
					} else if (location.pathname.includes('/users')) {
						if (context.securityOptions.userManagement < 1) {
							navigateToAllowedPage(context);
						}
					} else {
						navigateToAllowedPage(context);
					}

				}
			} catch (error) {
				console.error(error);
			}
		}
		getData();
	}, []);

	function navigateToAllowedPage(context) {
		// Check to see earliest accessible page and navigate to it
		if (context.securityOptions.contacts > 0) {
			navigate('/contacts');
		} else if (context.securityOptions.inventoryManagement > 0) {
			navigate('/segments');
		} else if (context.securityOptions.campaigns > 0) {
			navigate('/campaigns');
		} else if (context.securityOptions.communicationProfiles > 0) {
			navigate('/profiles');
		} else if (context.securityOptions.digitalChannels > 0) {
			navigate('/message-templates');
		} else if (context.securityOptions.suppression > 0) {
			navigate('/suppression');
		} else if (context.securityOptions.connection > 0) {
			navigate('/connection-details');
		} else if (context.securityOptions.userManagement > 0) {
			navigate('/user-management');
		} else if (context.securityOptions.auditLog > 0) {
			navigate('/audit-log');
		}
	}

	const setSecurityOptions = (options) => {
		return {
			contacts: +options[0],
			inventoryManagement: +options[1],
			campaigns: +options[2],
			communicationProfiles: +options[3],
			digitalChannels: +options[4],
			suppression: +options[5],
			liveAgentSelect: +options[6],
			connection: +options[7],
			userManagement: +options[8],
			auditLog: +options[9],
		};
	};

	const shouldNavigateToApprover = (options, approver) => {
		if (
			options.contacts === 0 &&
			options.inventoryManagement === 0 &&
			options.campaigns === 0 &&
			options.communicationProfiles === 0 &&
			options.digitalChannels === 0 &&
			options.suppression === 0 &&
			options.liveAgentSelect === 1 &&
			options.connection === 0 &&
			options.userManagement === 0 &&
			approver === '1'
		) {
			return true;
		}
		return false;
	};

	const openHelp = () => {
		window.open('https://stonly.com/guide/en/velocity-user-manual-P8Lmpcz7Jg/Steps/3653857');
	};

	const handleOpenUserMenu = (event) => {
		setUserBtn(event.currentTarget);
	};

	const handleCloseUser = () => {
		setUserBtn(null);
	};

	const handleContactUs = () => {
		window.location.href = 'mailto:support@customerDynamics.com';
	};

	const handleSignOut = () => {
		setUserBtn(null);
		signOut();
		navigate('/');
	};

	const handleMenuClick = () => {
		if (drawerVariant === 'temporary') {
			setDrawerOpen(!drawerOpen);
		} else if (drawerVariant === 'permanent') {
			setMiniDrawer(!miniDrawer);
		}
	};

	const shouldShowInventory = (options) => {
		return options.contacts > 0 || options.inventoryManagement > 0;
	};

	const shouldShowEngagement = (options, approver) => {
		return (
			options.campaigns > 0 ||
			options.communicationProfiles > 0 ||
			options.digitalChannels > 0 ||
			options.suppression > 0 ||
			options.liveAgentSelect > 0
		);
	};

	const shouldShowContactCenter = (options) => {
		return options.connection > 0;
	};

	const shouldShowAdmin = (options) => {
		return options.userManagement > 0;
	};

	return (
		<Box sx={{ display: 'flex' }}>
			<CssBaseline />
			<AppBar
				position="fixed"
				elevation={0}
				color="white"
				sx={
					drawerVariant === 'permanent'
						? { width: `calc(100% - ${drawerWidth}px)` }
						: { width: '100%' }
				}
			>
				<Toolbar>
					{drawerVariant === 'temporary' && (
						<Box
							sx={{
								display: 'block',
								padding: '8px',
							}}
						>
							<a href="/">
								<img
									src="/logo.svg"
									alt="Velocity Logo"
									style={{ width: '24px', height: 'auto' }}
								/>
							</a>
						</Box>
					)}
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="start"
						onClick={handleMenuClick}
						sx={{ mr: 2 }}
					>
						{/* <MenuIcon /> */}
						<MenuOutlined />
					</IconButton>
					{userContext.name && (
						<Button
							variant="text"
							aria-haspopup="true"
							onClick={handleOpenUserMenu}
							color="inherit"
							sx={{
								marginLeft: 'auto',
							}}
						>
							<Avatar {...stringAvatar(userContext.name, 35)} />
						</Button>
					)}
					<Menu
						id="userMenu"
						anchorEl={userBtn}
						keepMounted
						open={!!userBtn}
						onClose={handleCloseUser}
					>
						<Box sx={{ padding: '24px' }}>
							<Typography variant="h6">User Profile</Typography>
							{userContext.name && (
								<Box
									sx={{
										display: 'flex',
										direction: 'row',
									}}
								>
									<Avatar
										sx={{
											height: '25px',
											width: '25px',
										}}
										{...stringAvatar(userContext.name, 65)}
									/>
									<Box
										sx={{
											marginLeft: '12px',
										}}
									>
										<Typography
											variant="h6"
											sx={{
												textAlign: 'center',
												margin: '8px 0',
											}}
										>
											{userContext.name}
										</Typography>
										<Typography
											variant="body2"
											sx={{
												textAlign: 'center',
												margin: '8px 0',
											}}
										>
											{userContext.company}
										</Typography>
									</Box>
								</Box>
							)}
							<Divider />

							<MenuItem onClick={handleContactUs}>
								<ListItemIcon>
									<EmailOutlined />
								</ListItemIcon>
								Contact support
							</MenuItem>
							<MenuItem onClick={openHelp}>
								<ListItemIcon>
									<HelpOutlined />
								</ListItemIcon>
								Help documentation
							</MenuItem>
							{/* <MenuItem onClick={handleThemeChange}>
								<ListItemIcon>
									{themeMode === 'light' ? (
										<Brightness7Outlined />
									) : (
										<Brightness4Outlined />
									)}
								</ListItemIcon>
								{themeMode === 'light' ? 'Light Mode' : 'Dark Mode'}
							</MenuItem> */}
							<Button
								onClick={handleSignOut}
								startIcon={<LogoutOutlined />}
								variant="outlined"
								color="primary"
								sx={{ width: '100%', marginTop: '12px' }}
							>
								Logout
							</Button>
						</Box>
					</Menu>
				</Toolbar>
			</AppBar>
			<Drawer
				sx={{
					width: drawerWidth,
					flexShrink: 0,
					'& .MuiDrawer-paper': {
						width: drawerWidth,
						boxSizing: 'border-box',
					},
				}}
				variant={drawerVariant}
				anchor="left"
				open={drawerOpen}
				onClose={() => setDrawerOpen(false)}
			>
				{!miniDrawer && (
					<Box
						sx={{
							display: 'block',
							margin: '24px 24px 0 24px',
						}}
					>
						<a href="/">
							<img
								src="/velocity_horizontal.svg"
								alt="Velocity Logo"
								style={{ width: '100%', height: 'auto' }}
							/>
						</a>
					</Box>
				)}
				{miniDrawer && (
					<Box
						sx={{
							display: 'block',
							margin: '12px 12px 0 12px',
						}}
					>
						<a href="/">
							<img
								src="/logo.svg"
								alt="Velocity Logo"
								style={{ width: '100%', height: 'auto' }}
							/>
						</a>
					</Box>
				)}
				<SimpleBar style={{ maxHeight: 'calc(100vh - 120px)' }}>
					{/* Make padding 12px when mini */}
					<Box sx={{ overflow: 'auto', padding: miniDrawer ? '12px' : '24px' }}>
						<List>
							{shouldShowInventory(userContext.securityOptions) && (
								<ListSubheader sx={{ fontWeight: 700 }}>
									{miniDrawer ? '...' : 'INVENTORY'}
								</ListSubheader>
							)}

							{userContext.securityOptions.contacts > 0 && (
								<Fragment>
									<ListItem key={'contacts'} disablePadding>
										<ListItemButton
											sx={
												contactsOpen
													? listItemSelectedStyle
													: listItemButtonStyle
											}
											onClick={() => setContactsOpen(!contactsOpen)}
										>
											<ListItemIcon
												//reduce
												sx={
													contactsOpen
														? { ...listItemIconSelectedStyle }
														: { ...listItemIconStyle }
												}
											>
												{miniDrawer ? (
													<Tooltip title="Contacts" placement="right" arrow>
														<PeopleOutlined />
													</Tooltip>
												) : (
													<PeopleOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Contacts'} />}
											{!miniDrawer &&
												(contactsOpen ? <ExpandLess /> : <ExpandMore />)}
										</ListItemButton>
									</ListItem>
									<Collapse in={contactsOpen} timeout="auto" unmountOnExit>
										<List>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/contacts'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/contacts'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Contact Inventory"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Contact Inventory'} />
													)}
												</ListItemButton>
											</ListItem>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/custom-fields'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/custom-fields'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Custom Fields"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Custom Fields'} />
													)}
												</ListItemButton>
											</ListItem>
										</List>
									</Collapse>
								</Fragment>
							)}
							{userContext.securityOptions.inventoryManagement > 0 && (
								<Fragment>
									<ListItem key={'management'} disablePadding>
										<ListItemButton
											sx={
												managementOpen
													? listItemSelectedStyle
													: listItemButtonStyle
											}
											onClick={() => setManagementOpen(!managementOpen)}
										>
											<ListItemIcon
												sx={
													managementOpen
														? listItemIconSelectedStyle
														: listItemIconStyle
												}
											>
												{miniDrawer ? (
													<Tooltip title="Management" placement="right" arrow>
														<Inventory2Outlined />
													</Tooltip>
												) : (
													<Inventory2Outlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Management'} />}
											{!miniDrawer &&
												(managementOpen ? <ExpandLess /> : <ExpandMore />)}
										</ListItemButton>
									</ListItem>
									<Collapse in={managementOpen} timeout="auto" unmountOnExit>
										<List>
											{userContext.securityOptions.inventoryManagement > 1 && (
												<ListItem disablePadding>
													<ListItemButton
														sx={
															location.pathname === '/contact-import'
																? subListItemSelectedStyle
																: subListItemButtonStyle
														}
														component={Link}
														to={'/contact-import'}
													>
														<ListItemIcon>
															{miniDrawer ? (
																<Tooltip
																	title="Contact Import"
																	placement="right"
																	arrow
																>
																	<FiberManualRecordOutlined fontSize="small" />
																</Tooltip>
															) : (
																<FiberManualRecordOutlined fontSize="small" />
															)}
														</ListItemIcon>
														{!miniDrawer && (
															<ListItemText primary={'Contact Import'} />
														)}
													</ListItemButton>
												</ListItem>
											)}
											{userContext.securityOptions.inventoryManagement > 1 && (
												<ListItem disablePadding>
													<ListItemButton
														sx={
															location.pathname === '/bulk-edit'
																? subListItemSelectedStyle
																: subListItemButtonStyle
														}
														component={Link}
														to={'/bulk-edit'}
													>
														<ListItemIcon>
															{miniDrawer ? (
																<Tooltip
																	title="Bulk Management"
																	placement="right"
																	arrow
																>
																	<FiberManualRecordOutlined fontSize="small" />
																</Tooltip>
															) : (
																<FiberManualRecordOutlined fontSize="small" />
															)}
														</ListItemIcon>
														{!miniDrawer && (
															<ListItemText primary={'Bulk Management'} />
														)}
													</ListItemButton>
												</ListItem>
											)}
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/segments'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/segments'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Contact Segmentation"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Contact Segmentation'} />
													)}
												</ListItemButton>
											</ListItem>
											{userContext.securityOptions.inventoryManagement > 1 && (
												<ListItem disablePadding>
													<ListItemButton
														sx={
															location.pathname === '/field-mappings'
																? subListItemSelectedStyle
																: subListItemButtonStyle
														}
														component={Link}
														to={'/field-mappings'}
													>
														<ListItemIcon>
															{miniDrawer ? (
																<Tooltip
																	title="Field Mappings"
																	placement="right"
																	arrow
																>
																	<FiberManualRecordOutlined fontSize="small" />
																</Tooltip>
															) : (
																<FiberManualRecordOutlined fontSize="small" />
															)}
														</ListItemIcon>
														{!miniDrawer && (
															<ListItemText primary={'Field Mappings'} />
														)}
													</ListItemButton>
												</ListItem>
											)}
										</List>
									</Collapse>
								</Fragment>
							)}
							{shouldShowEngagement(userContext.securityOptions) && (
								<ListSubheader sx={{ fontWeight: 700 }}>
									{miniDrawer ? '...' : 'CUSTOMER ENGAGEMENT'}
								</ListSubheader>
							)}
							{userContext.securityOptions.campaigns > 0 && (
								<ListItem disablePadding>
									<ListItemButton
										sx={
											location.pathname === '/campaigns'
												? listItemSelectedStyle
												: listItemButtonStyle
										}
										component={Link}
										to={'/campaigns'}
									>
										<ListItemIcon
											sx={
												location.pathname === '/campaigns'
													? listItemIconSelectedStyle
													: listItemIconStyle
											}
										>
											{miniDrawer ? (
												<Tooltip title="Campaigns" placement="right" arrow>
													<CampaignOutlined />
												</Tooltip>
											) : (
												<CampaignOutlined />
											)}
										</ListItemIcon>
										{!miniDrawer && <ListItemText primary={'Campaigns'} />}
									</ListItemButton>
								</ListItem>
							)}
							{userContext.securityOptions.communicationProfiles > 0 && (
								<>
									<ListItem disablePadding>
										<ListItemButton
											sx={
												location.pathname === '/profiles'
													? listItemSelectedStyle
													: listItemButtonStyle
											}
											component={Link}
											to={'/profiles'}
										>
											<ListItemIcon
												sx={
													location.pathname === '/profiles'
														? listItemIconSelectedStyle
														: listItemIconStyle
												}
											>
												{miniDrawer ? (
													<Tooltip
														title="Communication Profiles"
														placement="right"
														arrow
													>
														<RecentActorsOutlined />
													</Tooltip>
												) : (
													<RecentActorsOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && (
												<ListItemText primary={'Communication Profiles'} />
											)}
										</ListItemButton>
									</ListItem>
									<ListItem disablePadding>
										<ListItemButton
											sx={location.pathname.includes('/manual-profiles') ? listItemSelectedStyle : listItemButtonStyle}
											component={Link}
											to={'/manual-profiles'}
										>
											<ListItemIcon
												sx={location.pathname.includes('/manual-profiles') ? listItemIconSelectedStyle : listItemIconStyle}
											>
												{miniDrawer ? (
													<Tooltip
														title="Manual Dialing"
														placement="right"
														arrow
													>
														<PhoneEnabledOutlined />
													</Tooltip>
												) : (
													<PhoneEnabledOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && (
												<ListItemText primary={'Manual Dialing'} />
											)}
										</ListItemButton>
									</ListItem>
								</>)}
							{userContext.securityOptions.digitalChannels > 0 && (
								<Fragment>
									<ListItem key={'omni'} disablePadding>
										<ListItemButton
											sx={
												omniOpen ? listItemSelectedStyle : listItemButtonStyle
											}
											onClick={() => setOmniOpen(!omniOpen)}
										>
											<ListItemIcon
												sx={
													omniOpen
														? listItemIconSelectedStyle
														: listItemIconStyle
												}
											>
												{miniDrawer ? (
													<Tooltip
														title="Digital Channels"
														placement="right"
														arrow
													>
														<ConnectWithoutContactOutlined />
													</Tooltip>
												) : (
													<ConnectWithoutContactOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && (
												<ListItemText primary={'Digital Channels'} />
											)}
											{!miniDrawer &&
												(omniOpen ? <ExpandLess /> : <ExpandMore />)}
										</ListItemButton>
									</ListItem>
									<Collapse in={omniOpen} timeout="auto" unmountOnExit>
										<List>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/message-templates'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/message-templates'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Message Templates"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Message Templates'} />
													)}
												</ListItemButton>
											</ListItem>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/digital-profiles'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/digital-profiles'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Digital Profiles"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Digital Profiles'} />
													)}
												</ListItemButton>
											</ListItem>
										</List>
									</Collapse>
								</Fragment>
							)}
							{userContext.securityOptions.suppression > 0 && (
								<Fragment>
									<ListItem key={'suppression'} disablePadding>
										<ListItemButton
											sx={
												suppressionOpen
													? listItemSelectedStyle
													: listItemButtonStyle
											}
											onClick={() => setSuppressionOpen(!suppressionOpen)}
										>
											<ListItemIcon
												sx={
													suppressionOpen
														? listItemIconSelectedStyle
														: listItemIconStyle
												}
											>
												{miniDrawer ? (
													<Tooltip title="Suppression" placement="right" arrow>
														<DoNotTouchOutlined />
													</Tooltip>
												) : (
													<DoNotTouchOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Suppression'} />}
											{!miniDrawer &&
												(suppressionOpen ? <ExpandLess /> : <ExpandMore />)}
										</ListItemButton>
									</ListItem>
									<Collapse in={suppressionOpen} timeout="auto" unmountOnExit>
										<List>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/suppression'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/suppression'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Suppression Profiles"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Suppression Profiles'} />
													)}
												</ListItemButton>
											</ListItem>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/dnc-lists'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/dnc-lists'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip title="DNC" placement="right" arrow>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && <ListItemText primary={'DNC'} />}
												</ListItemButton>
											</ListItem>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/contact-field-suppression'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/contact-field-suppression'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Contact Data Suppression"
																placement="right"
																arrow
															></Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText
															primary={'Contact Data Suppression'}
														/>
													)}
												</ListItemButton>
											</ListItem>
										</List>
									</Collapse>
								</Fragment>
							)}
							{userContext.telephonyProvider === 'NiC' &&
								userContext.securityOptions.liveAgentSelect > 0 && (
									<ListItem disablePadding>
										<ListItemButton
											sx={listItemButtonStyle}
											component={Link}
											to={'/approver'}
										>
											<ListItemIcon sx={listItemIconStyle}>
												{miniDrawer ? (
													<Tooltip
														title="Live Agent Select"
														placement="right"
														arrow
													>
														<AdsClickOutlined />
													</Tooltip>
												) : (
													<AdsClickOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && (
												<ListItemText primary={'Live Agent Select'} />
											)}
										</ListItemButton>
									</ListItem>
								)}
							{shouldShowContactCenter(userContext.securityOptions) && (
								<ListSubheader sx={{ fontWeight: 700 }}>
									{miniDrawer ? '...' : 'CONTACT CENTER'}
								</ListSubheader>
							)}
							{userContext.securityOptions.connection > 0 && (
								<Fragment>
									<ListItem key={'connection'} disablePadding>
										<ListItemButton
											sx={
												connectionOpen
													? listItemSelectedStyle
													: listItemButtonStyle
											}
											onClick={() => setConnectionOpen(!connectionOpen)}
										>
											<ListItemIcon
												sx={
													connectionOpen
														? listItemIconSelectedStyle
														: listItemIconStyle
												}
											>
												{miniDrawer ? (
													<Tooltip title="Connection" placement="right" arrow>
														<LeakAddOutlined />
													</Tooltip>
												) : (
													<LeakAddOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Connection'} />}
											{!miniDrawer &&
												(connectionOpen ? <ExpandLess /> : <ExpandMore />)}
										</ListItemButton>
									</ListItem>
									<Collapse in={connectionOpen} timeout="auto" unmountOnExit>
										<List>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/connection-details'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/connection-details'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Connection Details"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Connection Details'} />
													)}
												</ListItemButton>
											</ListItem>
											<ListItem disablePadding>
												<ListItemButton
													sx={
														location.pathname === '/disposition-mappings'
															? subListItemSelectedStyle
															: subListItemButtonStyle
													}
													component={Link}
													to={'/disposition-mappings'}
												>
													<ListItemIcon>
														{miniDrawer ? (
															<Tooltip
																title="Disposition Mappings"
																placement="right"
																arrow
															>
																<FiberManualRecordOutlined fontSize="small" />
															</Tooltip>
														) : (
															<FiberManualRecordOutlined fontSize="small" />
														)}
													</ListItemIcon>
													{!miniDrawer && (
														<ListItemText primary={'Disposition Mappings'} />
													)}
												</ListItemButton>
											</ListItem>
										</List>
									</Collapse>
								</Fragment>
							)}
							{shouldShowAdmin(userContext.securityOptions) && (
								<ListSubheader sx={{ fontWeight: 700 }}>
									{miniDrawer ? '...' : 'ADMINISTRATION'}
								</ListSubheader>
							)}
							{userContext.securityOptions.userManagement > 0 && (
								<ListItem disablePadding>
									<ListItemButton
										sx={
											location.pathname === '/users'
												? listItemSelectedStyle
												: listItemButtonStyle
										}
										component={Link}
										to={'/users'}
									>
										<ListItemIcon
											sx={
												location.pathname === '/users'
													? listItemIconSelectedStyle
													: listItemIconStyle
											}
										>
											{miniDrawer ? (
												<Tooltip title="Users" placement="right" arrow>
													<GroupOutlined />
												</Tooltip>
											) : (
												<GroupOutlined />
											)}
										</ListItemIcon>
										{!miniDrawer && <ListItemText primary={'Users'} />}
									</ListItemButton>
								</ListItem>
							)}
							{userContext.tenantRole === 'SuperAdmin' && (
								<>
									<ListItem disablePadding>
										<ListItemButton
											sx={location.pathname.includes('/licensing') ? listItemSelectedStyle : listItemButtonStyle}
											component={Link}
											to={'/licensing'}
										>
											<ListItemIcon
												sx={location.pathname.includes('/licensing') ? listItemIconSelectedStyle : listItemIconStyle}
											>
												{miniDrawer ? (
													<Tooltip title="Licensing" placement="right" arrow>
														<MonetizationOnOutlined />
													</Tooltip>
												) : (
													<MonetizationOnOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Licensing'} />}
										</ListItemButton>
									</ListItem>
									<ListItem disablePadding>
										<ListItemButton
											sx={location.pathname.includes('/tenants') ? listItemSelectedStyle : listItemButtonStyle}
											component={Link}
											to={'/tenants'}
										>
											<ListItemIcon
												sx={location.pathname.includes('/tenants') ? listItemIconSelectedStyle : listItemIconStyle}
											>
												{miniDrawer ? (
													<Tooltip title="Tenants" placement="right" arrow>
														<DomainOutlined />
													</Tooltip>
												) : (
													<DomainOutlined />
												)}
											</ListItemIcon>
											{!miniDrawer && <ListItemText primary={'Tenants'} />}
										</ListItemButton>
									</ListItem>
								</>
							)}
							{userContext.securityOptions.auditLog > 0 &&
								<ListItem disablePadding>
									<ListItemButton
										sx={location.pathname.includes('/audit-log') ? listItemSelectedStyle : listItemButtonStyle}
										component={Link}
										to={'/audit-log'}
									>
										<ListItemIcon
											sx={location.pathname.includes('/audit-log') ? listItemIconSelectedStyle : listItemIconStyle}
										>
											{miniDrawer ? (
												<Tooltip title="Audit Log" placement="right" arrow>
													<VerifiedOutlined />
												</Tooltip>
											) : (
												<VerifiedOutlined />
											)}
										</ListItemIcon>
										{!miniDrawer && <ListItemText primary={'Audit Log'} />}
									</ListItemButton>
								</ListItem>
							}
						</List>
					</Box>
				</SimpleBar>
			</Drawer>
			{/* Offset the main content to account for app bar */}
			<Box component="main" sx={{ flexGrow: 1, p: 3, marginTop: '64px' }}>
				<UserContext.Provider value={userContext}>
					<Outlet />
				</UserContext.Provider>
			</Box>
		</Box>
	);
}

export const AuthenticatedLayout = withAuthenticator(MainLayout, {
	hideSignUp: true,
	formFields,
	components,
});
